module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE/SURBVHgBhZLLbYNAEIZhsaUcXYJz8TXuwKSCxAbOwR2kg8QVpATwHQlcgXEH+MbNpIJQAI98E4FFrEUeabTz/v+dXcsYEc/zlovF4iHP81KXV7rgK1LX9VEpdcS0dTUT7TSlvpqmecf8Nk3zgzM17slms/HX6/Wl97G1qH+IruvaILwwfd62rY1u+wLsHfHAcZwMO4PNKYqi1JQm7hOQDNEC+5AkSXlz5zm5J3SJ6wOynVRVZRAwcPY0FDr6XbxgwBlEn/pWEUyhIGhyl7kxIpKTLQMQxnF8Ut3EXdccjDValhVIk9SKf33H6XR64JiNNTJYEMPevzYyTRZQDKkNqZPLULv3J4OJKxIpxTPOT/SNcMm7pgwVerIL2er+HyJylt8CnQsFP9iP6DNayOIkh2aGTvglK0G8jXe0l8PYLwW8rZQBhk8IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f3.png
// module id = APxr
// module chunks = 1